import graphqlClient from '~/graphql/graphqlClient';
import type {
  MutationNewsletterSignupArgs,
  NewsletterSignupResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation NewsletterSignup(
  $playerId: String!
  $email: String!
) {
  newsletterSignup(
    playerId: $playerId
    email: $email
  ) {
    ok
    detail
    currency1
  }
}
`;

export default async function mutationNewsletterSignup(
  args: MutationNewsletterSignupArgs
): Promise<NewsletterSignupResult> {
  return await graphqlClient.request<NewsletterSignupResult>(
    'newsletterSignup',
    mutation,
    args
  );
}
